import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "../index";
import httpClient from "../../utils/httpClient";
import { AxiosRequestConfig } from "axios";

interface UserData {
  displayName: string;
  id: string;
  email: string;
}
interface UserListType {
  id: string;
  displayName: string;
  email: string;
}
interface CtUserList {
  isLoading: boolean;
  data: UserListType[];
  error: string | null;
}

const initialState: CtUserList = {
  isLoading: false,
  data: [],
  error: null,
};

export interface ResponseError {
  message: string;
}
export interface RequestObject {
  searchText: string;
}
export const searchUsers = createAsyncThunk<
  any,
  RequestObject,
  { rejectValue: ResponseError }
>("UsersSlice/getUserSearchData", async (requestObject, thunkApi) => {
  try {
    const response = await httpClient.post("/users", requestObject, {
      signal: thunkApi.signal,
    } as AxiosRequestConfig);
    if (response.status != 200) {
      if (response.data.Status == "error") {
        return thunkApi.rejectWithValue({
          message: response.data.Message,
        });
      } else {
        return thunkApi.rejectWithValue({
          message: "Failed to fetch search user list.",
        });
      }
    }
    return response.data;
  } catch (error: any) {
    if (thunkApi.signal.aborted) {
      return thunkApi.rejectWithValue({ message: "Request cancelled" });
    }
    return thunkApi.rejectWithValue({
      message: "Failed to fetch search user list.",
    });
  }
});

const CTDBUserListSlice = createSlice({
  name: "CTDBUserListSlice",
  initialState,
  reducers: {
    resetSearchUsers: (state) => {
      state.isLoading = false;
      state.data = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchUsers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = [];
      })
      .addCase(
        searchUsers.fulfilled,
        (state, action: PayloadAction<UserData[]>) => {
          state.isLoading = false;
          state.data = action.payload;
          state.error = null;
        },
      )
      .addCase(searchUsers.rejected, (state, action: any) => {
        if (
          action.meta?.aborted ||
          action.payload?.message === "Request cancelled"
        ) {
          return;
        }
        state.isLoading = false;
        state.data = [];
        state.error = action.payload;
      });
  },
});

export const selectUserList = (state: RootState) => {
  return state.CTDBUserListSlice;
};

export const { resetSearchUsers } = CTDBUserListSlice.actions;

export default CTDBUserListSlice.reducer;
